import { Component, Inject, LOCALE_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppVersionService, IVersion } from "@services/app-version/app-version.service";
import { SharedModule } from "@shared/shared.module";
import { CdkDrag, CdkDropList, CdkDropListGroup } from "@angular/cdk/drag-drop";
import { NgIf } from "@angular/common";

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        SharedModule,
        RouterOutlet,
        CdkDrag,
        CdkDropList,
        CdkDropListGroup,
        NgIf
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    providers: []
})
export class AppComponent  {
    public isShowVersionModal = false
    public appVersion: IVersion = {
        actual: '',
        new: ''
    }

    constructor(
        private translateService: TranslateService,
        private appVersionService: AppVersionService,
        @Inject(LOCALE_ID) public locale: string | undefined
    ) {
        this.initAppVersion()
        const lang = this.locale?.split('-')[0].toLowerCase().slice(0, 2) || 'en';
        this.translateService.addLangs([lang]);
        this.translateService.setDefaultLang(lang);
    }


    private subscribeOnUpdateVersion(isVersionOld: IVersion | null) {
        this.isShowVersionModal = !!isVersionOld
        if (isVersionOld) {
            this.appVersion = isVersionOld
        }
    }

    private async initAppVersion(): Promise<void> {
        this.appVersionService.getIsVersionOld().subscribe(this.subscribeOnUpdateVersion.bind(this));
        this.appVersionService.checkAppVersion();
    }

    protected readonly window = window;

    public updateApp(): void {
        const url = new URL(window.location.href);
        url.searchParams.set('time', Date.now().toString());
        window.location.href = url.toString();
    }
}
